<script setup>
import { ref, computed, watch } from 'vue'
import UPDATE_USER_MUTATION from '@/graphql/User/UpdateUserMutation.gql'
import XInput from '@/components/common/XInput.vue'
import { useMutation } from '@vue/apollo-composable'
import FormProvider from "@/components/common/FormProvider.vue"


// Props
const {user, layout, disableSaving} = defineProps({
  user: {
    type: Object,
    required: true
  },
  layout: {
    type: String,
    default: 'stacked'
  },
  disableSaving: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['value'])

// Refs and Reactive Variables
const isUpdating = ref(false)

const structure = ref(
  user.userDetails.defaultRedirectParameters
    ? JSON.parse(user.userDetails.defaultRedirectParameters)
    : { kw: null, s1: null, s2: null, s3: null, s4: null, s5: null }
)

// Computed
const hasChanges = computed(() => {
  return JSON.stringify(structure.value) !== user.userDetails.defaultRedirectParameters
})

// Watchers
watch(
  structure,
  (newValue) => {
    emit('value', newValue)
  },
  { deep: true, immediate: true }
)



const { mutate: updateUser } = useMutation(UPDATE_USER_MUTATION)


async function update() {
  isUpdating.value = true
  try {
    const { data } = await updateUser({
      input: {
        id: user.id,
        userDetails: {
          update: {
            id: user.userDetails.id,
            defaultRedirectParameters: JSON.stringify({
              kw: structure.value.kw,
              s1: structure.value.s1,
              s2: structure.value.s2,
              s3: structure.value.s3,
              s4: structure.value.s4,
              s5: structure.value.s5
            })
          }
        }
      }
    })
    
  } catch (error) {
    console.error(error)
  } finally {
    isUpdating.value = false
  }
}

</script>

<template>
  <div>
    <FormProvider 
        bgColor="base-200"
      >
    <div v-if="layout === 'stacked'">
      <XInput class="mb-1" label="KW" v-model="structure.kw" />
      <XInput class="mb-1" label="S1" v-model="structure.s1" />
      <XInput class="mb-1" label="S2" v-model="structure.s2" />
      <XInput class="mb-1" label="S3" v-model="structure.s3" />
      <XInput class="mb-1" label="S4" v-model="structure.s4" />
      <XInput class="mb-1" label="S5" v-model="structure.s5" />
    </div>
    <div class="inline-flex" v-else-if="layout === 'inline'">

        <XInput
          label="KW"
          v-model="structure.kw"
          inputClass="!border-r-0 !rounded-r-none"
        />
        <XInput
          label="S1"
          v-model="structure.s1"
          inputClass="!border-r-0 !border-l-0 !rounded-none"
        />
        <XInput
          label="S2"
          v-model="structure.s2"
          inputClass="!border-r-0 !border-l-0 !rounded-none"
        />
        <XInput
          label="S3"
          v-model="structure.s3"
          inputClass="!border-r-0 !border-l-0 !rounded-none"
        />
        <XInput
          label="S4"
          v-model="structure.s4"
          inputClass="!border-r-0 !border-l-0 !rounded-none"
        />
        <XInput
          label="S5"
          v-model="structure.s5"
          inputClass="!border-l-0 !rounded-l-none"
        />

    </div>
    <!-- <ValidationErrors
      v-if="validationErrors && isVisible"
      :errors="validationErrors"
    ></ValidationErrors> -->
    <!-- <Teleport to="top-bar-right" v-if="hasChanges && isVisible && !disableSaving">
      <XButton @click="update()" color="accent">Update Redirect Params</XButton>
    </Teleport> -->
  </FormProvider>
  </div>
</template>